import { useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "./../../../../hooks";
import {
  getInstanceAsync,
  handleToggleInstanceRescueModal,
  rescueModeInstanceAsync,
  selectInstance,
  selectInstanceLoading,
  selectShowRescueModal,
} from "./../../../../store/instances/instanceSlice";
import { getInstancesAsync } from "./../../../../store/instances/instancesSlice";
import { Button, Flex, Modal, Typography } from "djuno-design";
import { useCallback, useEffect } from "react";

const InstanceExitRescueMode = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectShowRescueModal);
  const loading = useAppSelector(selectInstanceLoading);
  const instance = useAppSelector(selectInstance);

  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = useForm({
    shouldUnregister: true,
    reValidateMode: "onChange",
  });

  const onSubmit = (data: any) => {
    if (instance) {
      const formData = {
        instanceId: instance.id,
        rescue: false,
      };
      dispatch(
        rescueModeInstanceAsync({ instanceId: instance?.id, data: formData })
      ).then((action) => {
        if (action.type === "instance/rescue/fulfilled") {
          dispatch(getInstancesAsync({ withoutLoading: false }));
          dispatch(getInstanceAsync({ instanceId: instance.id }));
          handleOnClose();
        }
      });
    }
  };

  const handleOnClose = useCallback(() => {
    reset();
    dispatch(handleToggleInstanceRescueModal(false));
  }, [dispatch, reset]);

  useEffect(() => {
    return () => {
      handleOnClose();
    };
  }, [handleOnClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      contentClassName="max-w-lg"
      //containerClassName="!items-start"
      title="Exit rescue mode"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-5">
          <Typography.Text className="!text-sm mb-5">
            You are about to restart your {instance?.name} instance.
          </Typography.Text>
        </div>

        <Flex justify="end" className="mt-4 gap-2">
          <Button uiType="light" onClick={handleOnClose}>
            Cancel
          </Button>
          <Button
            uiType="primary"
            type="submit"
            disabled={!isValid}
            loading={loading}
          >
            Restart
          </Button>
        </Flex>
      </form>
    </Modal>
  );
};

export default InstanceExitRescueMode;
